export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const CREATEHEART = 'CREATEHEART';
export const UPDATEHEART = 'UPDATEHEART';
export const DELETEHEART = 'DELETEHEART';
export const FETCH_ALLHEART = 'FETCH_ALLHEART';
export const HEARTPREDICTION = 'HEART_PREDICTION';
export const GET_TOTALPAGES = 'GET_TOTALPAGES';

export const CREATESTROKE = 'CREATESTROKE';
export const UPDATESTROKE = 'UPDATESTROKE';
export const DELETESTROKE = 'DELETESTROKE';
export const FETCH_ALLSTROKE = 'FETCH_ALLSTROKE';
export const STROKEPREDICTION = 'STROKE_PREDICTION';

export const CREATEDIABETES = 'CREATEDIABETES';
export const UPDATEDIABETES = 'UPDATEDIABETES';
export const DELETEDIABETES = 'DELETEDIABETES';
export const FETCH_ALLDIABETES = 'FETCH_ALLDIABETES';
export const DIABETESPREDICTION = 'DIABETES_PREDICTION';

export const CREATELOAN = 'CREATELOAN';
export const UPDATELOAN = 'UPDATELOAN';
export const DELETELOAN = 'DELETELOAN';
export const FETCH_ALLLOAN = 'FETCH_ALLLOAN';
export const LOANPREDICTION = 'LOAN_PREDICTION';

export const CREATECREDIT = 'CREATECREDIT';
export const UPDATECREDIT = 'UPDATECREDIT';
export const DELETECREDIT = 'DELETECREDIT';
export const FETCH_ALLCREDIT = 'FETCH_ALLCREDIT';
export const CREDITPREDICTION = 'CREDIT_PREDICTION';

export const CREATEINSURANCE = 'CREATEINSURANCE';
export const UPDATEINSURANCE = 'UPDATEINSURANCE';
export const DELETEINSURANCE = 'DELETEINSURANCE';
export const FETCH_ALLINSURANCE = 'FETCH_ALLINSURANCE';
export const INSURANCEPREDICTION = 'INSURANCE_PREDICTION';